import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface IUsePosPhotosCheckBox {
	toggleUsePosPhotos: () => void;
	usePosPhotos: boolean;
}

const UsePosPhotosCheckBox: React.FC<IUsePosPhotosCheckBox> = ({ usePosPhotos, toggleUsePosPhotos }) => {
	return (
		<Form.Item name="usePosPhotos">
			<Checkbox checked={usePosPhotos} onChange={toggleUsePosPhotos}>
				<Text translationNameSpace="form" translationKey="usePosPhotosLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UsePosPhotosCheckBox);
